export default "__VITE_ASSET__BXk3ywOC__"